import {OpportunityViewModel} from "../../../../domain/bets-opportunities/models/opportunities/opportunity.view-model";
import classNames from "classnames";
import styles from "../style/game-card.module.scss";

export class GameCardOpportunityViewModel extends OpportunityViewModel {
  get ctaTextSpan(): String {
    const className: String = classNames(styles.textual_odds_cta_text);

    const ctaTextSpan: String = ` ${this.textCTA.addClassToSubString(className)} `;

    return ctaTextSpan;
  }
}
